var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/tick-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6376 8.53239L13.6377 8.53244L13.6436 8.52635C14.0573 8.0984 14.0657 7.41421 13.6376 6.98612C13.2128 6.56128 12.5162 6.56128 12.0914 6.98612L8.37575 10.7017L6.90847 9.23445C6.48363 8.80961 5.78704 8.80961 5.3622 9.23445C4.93735 9.6593 4.93735 10.3559 5.3622 10.7807L7.60261 13.0211C7.80615 13.2247 8.0833 13.3418 8.37575 13.3418C8.6682 13.3418 8.94536 13.2247 9.14889 13.0211L13.6376 8.53239ZM2.08325 9.99967C2.08325 5.91373 5.41398 2.58301 9.49992 2.58301C13.5859 2.58301 16.9166 5.91373 16.9166 9.99967C16.9166 14.0856 13.5859 17.4163 9.49992 17.4163C5.41398 17.4163 2.08325 14.0856 2.08325 9.99967Z",
    fill: "white",
    stroke: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdded);
export default __webpack_public_path__ + "static/media/added.be873e812820b548bc434a0a53f64dae.svg";
export { ForwardRef as ReactComponent };